// Modules
import { ViewChild, Renderer2, ViewChildren, QueryList, ViewContainerRef } from '@angular/core'; // AfterViewInit
import { Component, OnInit, Input, EventEmitter, Output, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
    MatPaginator,
    PageEvent,
    MatPaginatorIntl
} from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { TooltipPosition } from '@angular/material/tooltip';

// Components
import { SchoolsModalComponent } from '../schools-modal/schools-modal.component';

// Services/Models
import { ApiSchoolsService } from '../../../service/api-schools.service';
import { BaseLocalStorageService } from 'src/app/service/base-local-storage.service';
import {
    CONTACT_PERSON,
    EMAIL,
    ORGANIZATION,
    PartyRoleTypes,
    POSTAL_ADDRESSES,
    School,
    SCHOOL_STATUS,
    TELEPHONE_NUMBERS
} from 'src/app/model/school.model';
import { OrganizationService } from '../../common-components/organizations/service/organization.service';
import { County } from 'src/app/model/county';
import { Region } from '../../../model/region.model';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { SchoolSearchResult } from './model/SchoolSearchResult.model';
import { EditSchoolComponent } from '../edit-school/edit-school.component';
import { SchoolViewComponent } from '../school-view/school-view.component';
import { UtilityService } from 'src/app/service/utility.service';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { CreateSchoolComponent } from '../create-school/create-school.component';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { AccessService } from '../../navigation/service/access.service';
import { Organization } from 'src/app/model/organization/organization';
import { PartyContactMechanisms } from '../../party/model/party-contact-mechanisms.model';


@Component({
    selector: 'app-msin-mat-table',
    templateUrl: './msin-mat-table.component.html',
    styleUrls: ['./msin-mat-table.component.css']
})
export class MsinMatTableComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    @Output() onUpdateLabelEvent: EventEmitter<string> = new EventEmitter();
    @Output() onCheckCloseDialogEvent: EventEmitter<boolean> = new EventEmitter();
    @Output() onIsLoadingResultsEvent: EventEmitter<boolean> = new EventEmitter();
    @Output() onSearchErrorEvent: EventEmitter<string> = new EventEmitter();
    @Output() onRegionChangeEvent: EventEmitter<string> = new EventEmitter();

    @Input() searchParm: any = [{}];
    @Input() columnList!: string[];
    @Input() showViewIcon!: boolean;
    @Input() showPagination!: boolean;
    @Input() isLoadingResults: boolean = false;
    @Input() canClearFilter!: boolean;
    @Input() filterPlaceholder: string = '';
    @Input() allowAllRegions: boolean = false;

    @ViewChild('hoverTip') myHoverTip!: ElementRef;

    sortedData: School[];
    school: School;
    // general properties
    txtSearchResultsTitle: string = '';
    baseLocalStorageService: any;
    dataSource!: MatTableDataSource<School>;
    chosenCounties: County[] = [];
    chosenRegions: Region[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    displayedColumns: string[] = [
        'selectView',
        'REGIONS.CODE',
        'COUNTy.COUNTY_CODE',
        'DISTRICT',
        'NAME',
        'STREET_1',
        'PHONE',
        'cdscODE',
        'SCHOOL_STATUS.SCHOOL_STATUS_TYPES_ID'
    ]; //, 'DISTRICTS','REGION','COUNTY','DISTRICT','SCHOOL_NAME', 'ADDRESS','PHONE', 'CDS_Code', 'STATUS'];
    formCtlSelectSchool!: UntypedFormGroup;
    localStorageInfo$: Observable<any> = new Observable();
    myData!: School[];
    bAllowCreate: boolean = false;
    hasAdminRole: boolean = false;
    isLoading: boolean = false;
    schoolsService: any;
    organizationService: any;
    partyId: any = [{}];
    organizationId!: number;
    myOrganization!: ORGANIZATION;
    postalAddresses: POSTAL_ADDRESSES[] = [];
    displayPostalAddresses: string[] = [];
    actualContactMechanisms: any = [];

    hoverVal: string = '';
    bShowHoverTip = false;
    bHideColID = true;
    partyIdNum!: number;

    region: string = '';
    regionName: string = ''; // fully qualified name
    districtCode: string = '';
    ncesCode: string = '';
    NCES: string = '';
    closedDate: string = '';
    county: string = '';
    district: string = '';
    schoolType: string = '';
    SSID: string = '';
    CDSCode: string = '';
    gradeSpan: string = '';
    schoolStatus: string = '';
    schoolProperty: string = '';
    schoolName: string = '';
    mySchoolStatus: SCHOOL_STATUS;
    // MatPaginator Inputs
    length = 100;

    // Table results
    tableDataSource: MatTableDataSource<SchoolSearchResult>;
    results: SchoolSearchResult[] = [];

    // for hover over actions
    positionOptions: TooltipPosition[] = ['after', 'before', 'below', 'above', 'below', 'left', 'right'];
    position = new UntypedFormControl(this.positionOptions[3]);
    clickedRows: number[] = [];
    customHoverMessage: string = '';

    // for shoppingcart
    currentSortValue = '';

    // CREATE props start here
    bCancelCreate: boolean = false;
    createBtnText: string = 'Create';

    // security features setup
    featuresCheck = ['Create Schools', 'Edit School NCES', 'Edit Schools', 'View Schools', 'Search Schools'];
    featurePermissions: any = [];

    // dialog for create, options
    isOverflowEnabled = false;

    constructor(
        private renderer: Renderer2,
        schoolsService: ApiSchoolsService,
        organizationService: OrganizationService,
        _baseLocalStorageService: BaseLocalStorageService,
        private dialog: MatDialog,
        private fb: UntypedFormBuilder,
        private viewContainerRef: ViewContainerRef,
        private utilityService: UtilityService,
        private loginTokenService: LoginTokenService,
        private accessService: AccessService
    ) {
        this.schoolsService = schoolsService;
        this.organizationService = organizationService;
        this.baseLocalStorageService = _baseLocalStorageService;
        this.localStorageInfo$ = _baseLocalStorageService.myData$;
    }

    compare(a: number | string, b: number | string, isAsc: boolean) {
        var retVal = (a < b ? -1 : 1) * (isAsc ? 1 : -1);
        console.log('comp returning:' + retVal);
        return retVal;
    }

    strCompare(a: string, b: string, isAsc: boolean) {
        /* let aComp: string = a.toLowerCase();
     let bComp: string = b.toLowerCase();
 */

        var retVal = b.localeCompare(a, 'en', { caseFirst: 'lower', ignorePunctuation: true, sensitivity: 'variant' });
        console.log('now comparing names:' + a + ' with ' + b + ' strCompare returning: ' + retVal);
        return retVal;
    }

    onFocus(e: MouseEvent, inStr: string, colNum: number) {
        //  var myHover = document.getElementById('hoverTipID');
        this.bShowHoverTip = true;
        //if (myHover) {
        /* switch (colNum) {
        case 1: // region
          myHover.style.left = 100 + "px";//"600px";
          break;
        case 2: // county
          myHover.style.left = 200 + "px";
          break;
      }*/
        //if (e.clientY) {
        //  myHover.style.top = (e.clientY + 400) + "px";//"600px";
        //  myHover.style.objectPosition

        //}
        this.customHoverMessage = inStr;
        // }

        this.hoverVal = inStr;
    }

    onBlur(e: MouseEvent, colNum: number) {
        let xMin!: Number;
        let xMax!: Number;

        switch (colNum) {
            case 1:
                xMin = 355;
                xMax = 430;
                break;
            case 2:
                xMin = 395;
                xMax = 460;
                break;
        }
        /*
    if ((e.clientX < xMin) || (e.clientX > xMax)) {
      //    setTimeout(()=>{this.bShowHoverTip = false;},1200)
      this.bShowHoverTip = false;
    } */
        this.bShowHoverTip = false;
    }

    delay(time: number) {
        return new Promise((resolve) => setTimeout(resolve, time));
    }

    isEmpty(obj: any) {
        return Object.keys(obj).length === 0;
    }

    getSpecificSchools(bEmit: boolean) {
        console.log('calling getSpecificSchools at msinMatTable layer, with parm:' + bEmit);
        this.isLoadingResults = true;
        this.onIsLoadingResultsEvent.emit(this.isLoadingResults);
        const searchParmEntries = this.searchParm ? Object.values(this.searchParm) : [];
        const countiesInput = this.chosenCounties ? Object.values(this.chosenCounties) : [];
        const regionsInput = this.chosenRegions ? Object.values(this.chosenRegions) : [];
        const districtsInput = this.chosenSchoolDistricts ? Object.values(this.chosenSchoolDistricts) : [];

        if (this.chosenCounties) {
            if (countiesInput[0] != undefined && countiesInput[0] != null && !this.isEmpty(countiesInput[0])) {
                this.searchParm['chosenCounties'] = this.chosenCounties;
                console.log('official counties being fed into searchparm:' + this.chosenCounties);
            }
        }
        if (this.chosenRegions) {
            if (regionsInput[0] != undefined && regionsInput[0] != null && !this.isEmpty(regionsInput[0])) {
                this.searchParm['chosenRegions'] = this.chosenRegions;
                regionsInput.forEach((x) => {
                    console.log('official region being fed to searchParm:');
                    console.log(Object.entries(x));
                });
            }
        }
        if (this.chosenSchoolDistricts) {
            if (districtsInput[0] != undefined && districtsInput[0] != null && !this.isEmpty(districtsInput[0])) {
                var json_data = JSON.stringify(this.chosenSchoolDistricts);
                var result = json_data;
                this.searchParm['chosenSchoolDistricts'] = this.chosenSchoolDistricts;
                console.log('official districts being fed into searchparm:' + json_data);
            }
        }

        this.displayPostalAddresses = [];
        this.postalAddresses = [];
        let iRowIndex = -1;
        this.schoolsService.getSpecificSchools(this.searchParm).subscribe({
            next: (res: any) => {
                const mySchools: School[] = res['schools'];
                if (mySchools && mySchools.length > 0) {
                    this.results = mySchools;
                } else {
                    this.onSearchErrorEvent.emit('No school results. Please check your input.');
                }

                /*.sort((n1: SchoolSearchResult, n2: SchoolSearchResult) =>
            n1.NAME! > n2.NAME! ? 1 : -1
          );*/
                /* this.dataSource = new MatTableDataSource(res.schools);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          
          this.dataSource.filter = "";
          if (this.dataSource.data)
          {
            this.sortedData = this.dataSource.data ? this.dataSource.data.slice() : [];
          }*/
            },
            error: (err: any) => {
                this.onSearchErrorEvent.emit('error:' + err);
                console.log('error while getting school data: ' + err);
            },
            complete: () => {
                //console.log("data load completed. now calling updatedatasource")
                this.updateDataSource();

                // Expand all
                ///this.expandAll(this.results);
                // Display results
                this.isLoading = false;
                this.onIsLoadingResultsEvent.emit(false);
            }
        });
    }

    updateDataSource() {
        setTimeout(() => {
            let dataSource = new MatTableDataSource<SchoolSearchResult>();
            dataSource.data = this.results;
            dataSource.paginator = this.paginators?.toArray()[0];

            // Sort
            dataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'NAME', direction: 'asc' };
            dataSource.sort.active = defaultSort.active;
            dataSource.sort.direction = defaultSort.direction;
            dataSource.sort.sortChange.emit(defaultSort);
            dataSource.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);

            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.tableDataSource = dataSource;
            if (this.results?.length) {
                this.txtSearchResultsTitle = 'Search Results (' + this.results.length + ')';
            } else {
                this.txtSearchResultsTitle = 'Search Results';
            }
        });

        /*
        this.dataSource = new MatTableDataSource(results);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        
        this.dataSource.filter = "";
        if (this.dataSource.data)
        {
          this.sortedData = this.dataSource.data ? this.dataSource.data.slice() : [];
        }
        */
    }

    getProperty = (obj: any, path: string) => (path.split('.').reduce((o, p) => o && (o || {})[p], obj) || '').toLowerCase();

    toggleShow(obj: any) {
        obj.SHOW = !obj.SHOW;
    }

    expandAll(array: any[]) {
        array.forEach((obj) => {
            obj.SHOW = true;
        });
    }

    announceSortChange(sortState: Sort) {
        console.log('announceSortChange called');
    }

    fnFormatRegion(rowRegion: Region) {
        return rowRegion.ID;
    }

    fnFormatCounty(rowCounty: County) {
        return rowCounty.COUNTY_CODE;
    }

    fnFormatPostalAddress(organization?: Organization) {
        let retString: string = '';
        if (organization?.PARTy.PARTY_CONTACT_MECHANISMS) {
            organization.PARTy.PARTY_CONTACT_MECHANISMS.forEach((x: PartyContactMechanisms) => {
                if (x.PARTY_CONTACT_MECHANISM_PURPOSES != undefined) {
                    if (x.PARTY_CONTACT_MECHANISM_PURPOSES[0]?.CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE === 'Current Address') {
                        if (x.CONTACT_MECHANISMS?.POSTAL_ADDRESSES) {
                            if (x?.CONTACT_MECHANISMS?.POSTAL_ADDRESSES[0]?.STREET_1?.trimStart().trimEnd() != "") {
                                retString = 'C: ' + x?.CONTACT_MECHANISMS?.POSTAL_ADDRESSES[0]?.STREET_1?.trimStart().trimEnd() +
                                    ", " + x.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0]?.CITy?.CITY_NAME +
                                    ", " + x.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0]?.CITy?.STATE?.STATE_CODE +
                                    ", " + x.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0]?.POSTAL_CODES?.POSTAL_CODE;
                            }
                        }
                    }
                }
            });

        }
        return retString;
    }
    fnFormatMailingAddress(organization?: Organization) {
        let retString: string = '';
        if (organization?.PARTy.PARTY_CONTACT_MECHANISMS) {
            organization.PARTy.PARTY_CONTACT_MECHANISMS.forEach((x: PartyContactMechanisms) => {
                if (x.PARTY_CONTACT_MECHANISM_PURPOSES != undefined) {
                    if (x.PARTY_CONTACT_MECHANISM_PURPOSES[0]?.CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE === 'Mailing Address') {
                        if (x.CONTACT_MECHANISMS?.POSTAL_ADDRESSES) {
                            if (x?.CONTACT_MECHANISMS?.POSTAL_ADDRESSES[0]?.STREET_1?.trimStart().trimEnd() != "") {
                                retString = 'M: ' + x?.CONTACT_MECHANISMS?.POSTAL_ADDRESSES[0]?.STREET_1?.trimStart().trimEnd() +
                                    ", " + x.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0]?.CITy?.CITY_NAME +
                                    ", " + x.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0]?.CITy?.STATE?.STATE_CODE +
                                    ", " + x.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0]?.POSTAL_CODES?.POSTAL_CODE;
                            }
                        }
                    }
                }
            });

        }
        return retString;
    }

    fnGetStatusID(rowStatus: any) {
        const myStatus = rowStatus;
        return myStatus['SCHOOL_STATUS_TYPES_ID'];
    }

    fnFormatStatus(rowStatus?: number) {
        if (rowStatus) {
            switch (rowStatus) {
                case 1:
                    return 'Open';
                case 2:
                    return 'Close';
                    break;
            }
        }
        return '';
    }

    getPartyRoleTypesByCategory(body: any) {
        this.schoolsService.getPartyRoleTypeByCategory(body).subscribe({
            next: (res: any) => {
                const myPartyRoleTypeByCategory: PartyRoleTypes[] = res.partyRoleTypes;
            },
            error: (err: any) => {
                console.log('error while getting getPartyRoleTypesByCategory data');
            }
        });
    }

    fnParseCity(cityData: any) {
        if (Object.values(cityData)[2]) return Object.values(cityData)[2];
        else return '';
    }

    fnParseState(cityData: any) {
        // Note: State info is inside the city model!
        const myCityShell: any = cityData.STATE;
        if (myCityShell['STATE_CODE']) return myCityShell['STATE_CODE'];
        else return '';
    }

    fnParseZip(zipData: any) {
        if (zipData['POSTAL_CODE']) return zipData['POSTAL_CODE'];
        else return '';
    }

    // takes multiple contact mechanisms, extracts exactly only 1 address which is valid
    fnExtractAddress(dataSrc: POSTAL_ADDRESSES[]) {
        var retString: string = '';
        var iStart = 0;

        if (dataSrc) {
            for (var i = iStart; i < dataSrc.length; i++) {
                if (dataSrc[i]) {
                    try {
                        if (dataSrc[i].STREET_1) {
                            if (i == 0) {
                                retString = retString + 'C: '; // "<b>C:</b>";
                            } else {
                                retString = retString + 'M: '; // "<b>M:</b>"
                            }
                            retString =
                                retString +
                                dataSrc[i].STREET_1 +
                                `, ` +
                                (dataSrc[i].STREET_2 ? dataSrc[i].STREET_2 + `, ` : '') +
                                this.fnParseCity(dataSrc[i].CITy) +
                                `, ` +
                                this.fnParseState(dataSrc[i].CITy) +
                                `, ` +
                                this.fnParseZip(dataSrc[i].POSTAL_CODES) +
                                `\r\n`;
                        }
                    } catch (Err) {
                        console.log('ERROR filling address:' + Err);
                    }
                }
            }
        }
        return retString;
    }

    ngOnInit(): void {
        this.formCtlSelectSchool = new UntypedFormGroup({
            txtFilter: new UntypedFormControl(null, [Validators.required]),
            hoverTipObj: new UntypedFormControl(null)
        });

        this.initUser();

        this.getFeaturePermissions();
    }

    getFeaturePermissions() {
        try {
            this.accessService.getFeatureAccessPromise(this.featuresCheck).then((res) => {
                this.featurePermissions = res;
            });
        } catch (Err) {
            console.log('error getting feature permission in msin-mat-table.component:' + Err);
        }
    }

    initUser() {
        let user = this.loginTokenService.getUser();
        let adminUserIds = [1, 9]; // System Administrator (1), State Administrator (9)
        this.hasAdminRole = user.USER_ROLES?.some((ur) => adminUserIds.includes(ur.ROLE?.ID ? ur.ROLE.ID : 0))!;
        console.log('hasAdminRole:');
        console.log(this.hasAdminRole);
        if (this.hasAdminRole || this.allowAllRegions) {
            // && !this.disabled
            this.bAllowCreate = true;
        } else {
            this.bAllowCreate = true;
        }
    }

    fnShowViewIcon() {
        this.showViewIcon = !this.showViewIcon;
    }

    fnShowPagination() {
        this.showPagination = !this.showPagination;
    }

    fnReset() {
        this.formCtlSelectSchool.controls['txtFilter'].reset();

        this.searchParm = [];
        this.chosenCounties = [];
        this.chosenRegions = [];
        this.chosenSchoolDistricts = [];

        var origItemCount = 0;
        try {
            console.log('data source length:' + this.dataSource.data.length);
            origItemCount = this.dataSource.data.length;
        } catch (Err) {
            console.log('defaulting to 0');
            origItemCount = 0;
        }

        this.applyFilter();
    }

    get f() {
        return this.formCtlSelectSchool.controls;
    }

    applyFilter(event?: Event) {
        let filterValue = '';
        if (event) {
            filterValue = (event.target as HTMLInputElement).value;
        }
        var origItemCount = 0;

        if (this.tableDataSource) {
            try {
                origItemCount = this.tableDataSource?.data?.length;
            } catch (Err) {
                console.log('error getting dataSourceLength:' + Err);
                origItemCount = 0;
            }
            if (origItemCount > 0) {
                this.tableDataSource.filter = filterValue.trim().toLowerCase();
                /* if (this.dataSource.paginator) {
          this.dataSource.paginator.firstPage();
        }*/
            }
        }

        if (this.dataSource?.data) {
            try {
                origItemCount = this.dataSource.data.length;
                console.log('orig item count: ' + origItemCount);
            } catch (Err) {
                console.log('error getting dataSourceLength:' + Err);
                origItemCount = 0;
            }
            if (origItemCount > 0) {
                this.dataSource.filter = filterValue.trim().toLowerCase();
                /* if (this.dataSource.paginator) {
          this.dataSource.paginator.firstPage();
        }*/
            }
        } else {
            console.log('filter thinks there is no data');
        }
    }

    openDialog(row: any) {
        const dialogRef = this.dialog.open(SchoolsModalComponent, {
            width: '90%',
            height: '90%',
            data: row
        });

        dialogRef.afterClosed().subscribe((result) => {
            // console.log("now resetting msin school search")
            /// this.contactInfoForm.reset();
            // console.log("result incoming:")
            // console.log(result)
            // console.log("row object will change now")
            // console.log(row)
            /// this.ngOnInit();
            /// this.onRegionChangeEvent.emit(result['REGIONS']);
        });
    }

    edit(row: any) {
        //    this.accountService.getAccount({ id: row.ID }).subscribe((x) => {
        //        let u: UserModel = x;

        const dialogRef = this.dialog.open(EditSchoolComponent, {
            disableClose: true,
            width: '98%',
            height: '90%',
            data: row,
            viewContainerRef: this.viewContainerRef
        });
        dialogRef.afterClosed().subscribe((result) => {
            // console.log("passing result")
            // console.log(result);
            // this.fnInit(row);
            this.getSpecificSchools(true);
            /*: UserModel) => {
            if (result != undefined) {
                let index = this.dataSource.data.findIndex((x) => x.ID === result.ID);
                if (index >= 0) {
                    this.dataSource.data[index].LOGIN_DETAIL_STATUS = result.LOGIN_DETAIL_STATUS;
                    this.dataSource.data[index].PERSON!.FIRST_NAME = result.PERSON?.FIRST_NAME;
                    this.dataSource.data[index].PERSON!.LAST_NAME = result.PERSON?.LAST_NAME;
                    this.dataSource.data[index].EMAIL_ADDRESS = result.EMAIL_ADDRESS;
                    this.dataSource.data[index].WORK_TITLE = result.WORK_TITLE;
                    this.dataSource.data[index].WORKS_FOR = result?.WORKS_FOR;
                    this.dataSource.data[index].SCHOOL_DISTRICTS = result.SCHOOL_DISTRICTS;
                    this.dataSource.data[index].REGION = result?.REGION;
                    this.dataSource.data[index].USER_ROLES = result?.USER_ROLES;
                }
            }
        });*/
        });
    }

    fnInit(row: any) {
        // set school object
        this.schoolsService.show(row['ID']).subscribe((res: SchoolViewComponent) => {
            console.log('thisSchool: ');
            this.school = res.school;
            console.log(this.school);

            // set school data
            this.region = this.school.REGION; //this.editData['REGION'];
            const regionShell = this.school.REGIONS; //this.editData['REGIONS'];
            this.regionName = regionShell['NAME'] || '';

            const districtShell = this.school.SCHOOL_DISTRICT.DISTRICTS; // this.editData['SCHOOL_DISTRICT'];
            this.districtCode = this.school.SCHOOL_DISTRICT.CODE.toString(); //districtShell['CODE'].toString();
            const ncesShell = this.school.SCHOOL_DISTRICT.NCESDist; //this.editData['NCES'];
            this.ncesCode = this.school.SCHOOL_DISTRICT?.NCESDist.toString() || '';
            this.NCES = this.school.SCHOOL_NCES;

            const districtOrganizationShell = this.school.SCHOOL_DISTRICT.ORGANIZATION.NAME; ////districtShell['ORGANIZATION'];

            var translateCounty = this.school.COUNTy.COUNTY_NAME; //(Object.values(this.editData['COUNTy'])?.toString()).split(',');
            this.county = translateCounty + ' (' + this.school.COUNTy.ID + ')'; // translateCounty[2] + " (" + translateCounty[3] + ")";
            this.district = this.school.DISTRICT; // this.editData['DISTRICT'];
            this.schoolType = this.school.SCHOOL_TYPE?.TYPE; //this.editData['SCHOOL_TYPE_ID'];
            this.SSID = this.school.SSID; // editData['SSID'];
            this.CDSCode = this.school.cdscODE; //this.editData['cdscODE'];
            this.gradeSpan = this.utilityService.fnFormatGradeSpan(this.school.LOW_GRADES, this.school.HIGH_GRADES);

            var translateSchoolStatus: number; //string[] = [];
            translateSchoolStatus = this.school.SCHOOL_STATUS.SCHOOL_STATUS_TYPES_ID; //(Object.values(this.school.SCHOOL_STATUS.toString()).split(',')); //this.editData['SCHOOL_STATUS'])
            this.schoolStatus = translateSchoolStatus == 1 ? 'Open' : 'Close/Merged'; //translateSchoolStatus[2]

            this.schoolProperty = this.school.SCHOOL_PROPERTY_TYPES?.TYPE;

            this.mySchoolStatus = this.school.SCHOOL_STATUS;
            if (this.mySchoolStatus) {
                if (this.mySchoolStatus.CLOSE_DATE) {
                    this.closedDate = new CleanDatePipe().transform(this.mySchoolStatus.CLOSE_DATE);
                    var cleanDate = new Date(this.closedDate);
                    console.log('closed date from : ' + cleanDate.getTime());
                    if (cleanDate.getTime() == -62135596800000) {
                        // handle invalid date
                        this.closedDate = '';
                    }
                }
            }
            this.schoolName = this.school.NAME; //this.editData['NAME'];

            /*  console.log("incomingData:" + this.region + "," + this.county + "," + this.district
        + "," + this.schoolType + "," + this.SSID
        + "," + this.CDSCode + "," + this.NCES
        + "," + this.gradeSpan + "," + this.schoolStatus
        + "," + this.schoolProperty + "," + this.closedDate
        + "," + this.schoolName
      ); */

            this.isLoading = false;

            // load party data
            if (this.school.ORGANIZATIONS_ID) {
                this.organizationId = this.school.ORGANIZATIONS_ID; //this.editData['ORGANIZATIONS_ID'];

                this.organizationService.show(this.organizationId).subscribe({
                    next: (res: any) => {
                        this.myOrganization = res.organization;
                        console.log('organization is: ' + Object.entries(this.myOrganization));
                        console.log('party ids are: ' + this.myOrganization.PARTIES_ID);
                        this.partyId = this.myOrganization.PARTIES_ID;

                        this.partyIdNum = parseInt(this.partyId);
                        // this.getPartyRoleTypesByCategory({ 'partyRoleCategoryType': 'ORGANIZATION' });

                        console.log('inbound organization id1 is: ' + this.organizationId);

                        console.log('my organization: ' + this.myOrganization.PARTIES_ID);
                    },
                    error: (err: any) => {
                        alert('Error while fetching the records');
                        console.log('error while getting organization data');
                    }
                });
            }
        });
    }

    fnCreate() {
        // this.onCreateEvent.emit();
        const dialogRef = this.dialog.open(CreateSchoolComponent, {
            width: '100%', // '99%',
            height: '80%', // '600px', //'80%',
            panelClass: 'largescreen-dialog',
            data: { isOverflowEnabled: this.isOverflowEnabled, isCreated: false },
            viewContainerRef: this.viewContainerRef,
            disableClose: true
        });
        dialogRef.componentInstance.createdStatusChanged.subscribe((isCreated) => {
            console.log('Parent received the change:', isCreated);
        })
        dialogRef.afterClosed().subscribe((result) => {
            // this.ngOnInit();
            // this.onRegionChangeEvent.emit(result['REGIONS'])
        });
    }

    fnSelectRow(row: School, ind: number) {
        if (this.clickedRows.includes(ind)) {
            this.clickedRows = this.arrayRemove(this.clickedRows, ind);
        } else {
            this.clickedRows.push(ind);
        }
    }

    arrayRemove(arr: number[], value: number) {
        return arr.filter(function (ele) {
            return ele != value;
        });
    }

    fnCheckRow(row: School, ind: number) {
        /*console.log("check row: " )
    if (row)
    {
      console.log("found row")
      console.log(row)
      console.log(row.NAME)
    }*/
        return this.clickedRows.includes(ind);
    }

    checkCanEditSchoolNCES() {
        var feature = 'Edit School NCES';

        /*    Auth.resolveFeature(feature, true).then(function (has) {
        $scope.canEditSchoolNCES = has;
    }, function (err) {
        $scope.canEditSchoolNCES = false;
    });*/
    }

    toggleOverflow() {
        this.isOverflowEnabled = !this.isOverflowEnabled;
        console.log("toggling overflow in msinmattable");
    }
}
